/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="orderNumber" placeholder="输入订单号"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-select size="small" v-model="status" placeholder="请选择">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->

      <el-select v-model="cityName" placeholder="请选择">
        <el-option
          v-for="item in cityNameList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getOrderList(1)">搜索</el-button>
      </el-form-item>


    <el-form-item>

  <div class="block">
    <span class="demonstration">选择时间</span>
    <el-date-picker
      v-model="value2"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      align="right">
    </el-date-picker>
  </div>
</el-form-item>



    </el-form>
    <!-- <el-form :inline="true" >
      <el-form-item label="汇总：">
          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span style="margin-right: 10px;">订单总金额:{{sumData.data0/100}}元</span>
          </div>
          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>订单支付总金额：{{sumData.data1/100}}元</span>
          </div>



          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>用户收入总额：{{sumData.data3/100}}元</span>
          </div>

          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>用户提现支出总额：{{sumData.data4/100}}元</span>
          </div>

          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>总提现：{{sumData.data5/100}}元</span>
          </div>

          
          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>总抽成：{{sumData.data6/100}}元</span>
          </div>
          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>取消订单手续费：{{sumData.data7/100}}元</span>
          </div>
        </el-form-item>
    </el-form> -->


    <!-- <el-form :inline="true" >
      <el-form-item label="汇总：">

          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>用户消费总计：{{sumData.data1/100}}元</span>
          </div>

          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>平台抽成总计：{{sumData.data6/100}}元</span>
          </div>



          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>接单方收取服务费总计（不包括平台收取的抽成）:{{sumData.data3/100}}元</span>
          </div>


          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>上门费总计：{{sumData.data8/100}}元</span>
          </div>

          
        </el-form-item>
    </el-form> -->

    <el-form :inline="true" >
      <el-form-item label="汇总：">

          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>用户消费总计：{{(sumData.data6+sumData.data3+sumData.data8)/100}}元</span>
          </div>

          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>平台抽成总计：{{sumData.data6/100}}元</span>
          </div>



          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>接单方收取服务费总计（不包括平台收取的抽成）:{{sumData.data3/100}}元</span>
          </div>


          <div style="color: brown; font-size: 18px; font-weight: 600;"> 
            <span>上门费总计：{{sumData.data8/100}}元</span>
          </div>

          
        </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column prop="id" width="60">
      </el-table-column>
      <el-table-column sortable prop="payType" label="下单人昵称" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.memberBuyer.username }}</div>
        </template>
      </el-table-column>

      <el-table-column sortable prop="payType" label="下单人手机号" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.memberBuyer.mobile }}</div>
        </template>
      </el-table-column>

      <el-table-column sortable prop="payType" label="下单人头像" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image style="width: 80px; height: 80px;border-radius: 10px;"
          :src="$adminImageUrl(scope.row.memberBuyer && scope.row.memberBuyer.headPortrait)"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable prop="payType" label="接单人昵称" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.memberSeller.username }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="payType" label="接单人手机号" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.memberSeller.mobile }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="payType" label="接单人头像" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image style="width: 80px; height: 80px;border-radius: 10px;"
          :src="$adminImageUrl(scope.row.memberSeller && scope.row.memberSeller.headPortrait)"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable prop="orderNumber" label="订单号" width="210" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="payType" label="支付方式" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.payType==2">
            
            微信支付
          </div>
          <div v-if="scope.row.payType==1">
            
            支付宝支付
          </div>
        </template>
      </el-table-column>

      
      <el-table-column sortable prop="orderPrice" label="技能服务价格" width="130" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.basicCost / 100 }}</div>
        </template>

      </el-table-column>



      

      <el-table-column sortable prop="payPrice" label="平台抽成" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.serviceCharge / 100 }}</div>
        </template>
      </el-table-column>

      <el-table-column sortable prop="payPrice" label="上门费" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.costKm / 100 }}</div>
        </template>
      </el-table-column>


      <el-table-column sortable prop="payPrice" label="支付金额" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.payPrice / 100 }}</div>
        </template>
      </el-table-column>


      <el-table-column prop="addTime" label="技能图" width="100">
        <template slot-scope="scope">
          <el-image style="width: 80px; height: 80px;border-radius: 10px;"
            :src="getMainImg(scope.row.skillData)"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable label="技能名称"  :fit="true" show-overflow-tooltip width="240">
        <template slot-scope="scope">
          <div>{{ getClassName(scope.row.skillData) }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="status" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">待接单</div>
          <div v-if="scope.row.status == 2">待服务</div>
          <div v-if="scope.row.status == 3">服务中</div>
          <div v-if="scope.row.status == 4">待确认</div>
          <div v-if="scope.row.status == 5">待评价</div>
          <div v-if="scope.row.status == 6">已完成</div>
          <div v-if="scope.row.status == 7">已取消</div>
        </template>

      </el-table-column>
      <el-table-column sortable prop="createTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="affirmOrder(scope.$index, scope.row)">确认完成</el-button>
          <el-button size="mini" type="danger" @click="setOrderRefund(scope.$index, scope.row)">退款</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog v-if="false" :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" v-if="orderInfo">
        <el-row>
          <el-col :span="12">
            <el-form-item label="买家昵称">
              <el-input size="small" v-model="buyerInfo.username" auto-complete="off" placeholder="请输入名称" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="卖家昵称">
              <el-input size="small" v-model="sellerInfo.username" auto-complete="off" placeholder="请输入商户号" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input size="small" v-model="orderInfo.orderNumber" auto-complete="off" placeholder="请输入商户号" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="支付方式">
              <el-input size="small" v-if="orderInfo.payType == 0" auto-complete="off" placeholder="余额支付" disabled>
              </el-input>
              <el-input size="small" v-if="orderInfo.payType == 1" auto-complete="off" placeholder="支付宝支付" disabled>
              </el-input>
              <el-input size="small" v-if="orderInfo.payType == 2" auto-complete="off" placeholder="微信支付" disabled>
              </el-input>

            </el-form-item>

            <el-form-item label="支付金额">
              <el-input size="small" auto-complete="off" :placeholder="orderInfo.orderPrice / 100" disabled></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="买家电话">
              <el-input size="small" v-model="buyerInfo.mobile" auto-complete="off" placeholder="请输入名称" disabled>
              </el-input>
            </el-form-item>
            <el-form-item label="卖家电话">
              <el-input size="small" v-model="sellerInfo.mobile" auto-complete="off" placeholder="请输入名称" disabled>
              </el-input>
            </el-form-item>


            <el-form-item label="商品价格">
              <el-input size="small" auto-complete="off" :placeholder="orderInfo.orderPrice / 100" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-input size="small" v-model="editForm.goodsName" auto-complete="off"
                :placeholder="JSON.parse(orderInfo.goodsData).title" disabled></el-input>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-input size="small" v-if="orderInfo.status == 1" auto-complete="off" placeholder="待发货" disabled>
              </el-input>
              <el-input size="small" v-if="orderInfo.status == 2" auto-complete="off" placeholder="待收货" disabled>
              </el-input>
              <el-input size="small" v-if="orderInfo.status == 3" auto-complete="off" placeholder="已完成" disabled>
              </el-input>
              <el-input size="small" v-if="orderInfo.status == 4" auto-complete="off" placeholder="已取消" disabled>
              </el-input>

            </el-form-item>

          </el-col>
        </el-row>
        <el-form-item label="创建时间">
          <el-input size="small" v-if="orderInfo.createTime" auto-complete="off"
            :placeholder="transformDate(orderInfo.createTime)" disabled></el-input>
        </el-form-item>
        <el-form-item label="付款时间">
          <el-input size="small" v-if="orderInfo.paytime" auto-complete="off"
            :placeholder="transformDate(orderInfo.paytime)" disabled></el-input>
        </el-form-item>
        <el-form-item label="发货时间">
          <el-input size="small" v-if="orderInfo.deliveryTime" auto-complete="off"
            :placeholder="transformDate(orderInfo.deliveryTime)" disabled></el-input>
        </el-form-item>
        <el-form-item label="收货时间">
          <el-input size="small" v-if="orderInfo.receivingTime" auto-complete="off"
            :placeholder="transformDate(orderInfo.receivingTime)" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, getOrderDetails, setOrderRefund, affirmOrder,getClassifyList,getAdminCityNameData,getCityNameList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      cityName:"",
      cityNameList:[],
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value2: '',



      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',

      orderNumber: "",
      status: 0,
      payType: [
        { key: '请选择', value: 0 },
        { key: '待发货', value: 2 },
        { key: '待收货', value: 3 },
        { key: '已完成', value: 4 },
        { key: '已取消', value: 5 }
      ],

      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: '',
        orderNo: '',
        transId: '',
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem('logintoken')
      },

      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      orderInfo: {},
      sellerInfo: {},
      buyerInfo: {},
      classifyTwoList: [],
      classifyList:[],

      sumData:{}

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getClassifyList()
    this.getOrderList(1)

    this.getAdminCityNameData()

    this.getCityNameList()


  },
  computed: {
    payTypeHint(payType) {

      if (payType==2) {
        

        return "微信支付";
      }
      return payType => {

        if (payType == 0) return '余额支付'
        payType == 1 ? "支付宝支付" : "微信支付"
      }
    },
    getClassName() {
      return data => {
        let skillData = JSON.parse(data)
        
        let id = skillData.classifyTwoId
        var name = "点击选择";
        if (this.classifyTwoList.length > 0) {
          for (var i = 0; i < this.classifyTwoList.length; i++) {
            if (this.classifyTwoList[i].id == id) {
              name = this.classifyTwoList[i].name
              for (var j = 0; j < this.classifyList.length; j++) {
                if (this.classifyTwoList[i].parentId == this.classifyList[j].id) {

                  name = this.classifyList[j].name + "-" + name
                }
              }
            }
          }
          return name;
        }else{
          return '暂无'
        }

      }

    },
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getMainImg(goodsData) {
      try {
        const data = typeof goodsData === 'string' ? JSON.parse(goodsData) : goodsData
        return this.$adminImageUrl(data && data.skillImage)
      } catch (error) {
        return ''
      }
    },
    getClassifyList() {
      getClassifyList().then(res => {
        if (res.code == 200) {
          this.classifyList = res.data.classifyList
          this.classifyTwoList = res.data.classifyTwoList
        }
      })
    },
    getCityNameList() {
      getCityNameList().then(res => {
        if (res.code == 200) {
          this.cityNameList = res.data.list
        }
      })
    },

    
        // 获取订单列表
    getAdminCityNameData() {


      var endTime = 1988888888;
      var beginTime = 0;


      if (this.value2) {
        beginTime = parseInt(this.value2[0].getTime()/1000);
        endTime = parseInt(this.value2[1].getTime()/1000);

      }







      this.loading = true;
      var parameter = {
        cityName: "",
        beginTime: beginTime,
        cityName:this.cityName,
        endTime: endTime
      };
      getAdminCityNameData(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {

          this.sumData = res.data;
          console.log('111111111111', res.data)
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    // 获取订单列表
    getOrderList(page) {

      this.getAdminCityNameData()

      var endTime = 1988888888;
      var beginTime = 0;


      if (this.value2) {
        beginTime = parseInt(this.value2[0].getTime()/1000);
        endTime = parseInt(this.value2[1].getTime()/1000);

      }

      this.loading = true;
      var parameter = {
        orderNumber: this.orderNumber,
        status: this.status - 1,
        beginTime: beginTime,
        endTime: endTime,
        cityName:this.cityName,
        page: (page - 1) * 20

      };
      getOrderList(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          console.log('res.data.list', res.data.orderEntityList)
          this.listData = res.data.orderEntityList
          this.pageparm.currentPage = page
          this.pageparm.total = res.data.orderEntityList.length
          // this.listData = res.data.list;
          this.orderInfo = this.listData[0];
          // this.pageparm.currentPage = page;
          // this.pageparm.total = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    // 获取订单详情
    getOrderDetails() {
      this.loading = true;
      var parameter = {
        orderNumber: this.orderInfo.orderNumber
      };
      getOrderDetails(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.sellerInfo = res.data.sellerInfo;
          this.buyerInfo = res.data.buyerInfo;

          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      this.getOrderList(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getOrderList(1)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.orderInfo = row;
      this.getOrderDetails()
    },
    affirmOrder(index, row) {
      this.$confirm('确定要完成吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          affirmOrder({ orderNumber: row.orderNumber })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getOrderList(1)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    setOrderRefund(index, row) {
      this.$confirm('确定要退款吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setOrderRefund({ orderNumber: row.orderNumber })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg || '退款申请已提交'
                })
                this.getOrderList(1)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/Order.vue